import NavTab from './nav-tab'

export default NavTab
